import { render, staticRenderFns } from "./fileTypes-editor.vue?vue&type=template&id=3094caba&scoped=true"
import script from "./fileTypes-editor.vue?vue&type=script&lang=js"
export * from "./fileTypes-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3094caba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3094caba')) {
      api.createRecord('3094caba', component.options)
    } else {
      api.reload('3094caba', component.options)
    }
    module.hot.accept("./fileTypes-editor.vue?vue&type=template&id=3094caba&scoped=true", function () {
      api.rerender('3094caba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/fileTypes-editor.vue"
export default component.exports